import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { GoPlusCircle } from "react-icons/go";
import useTitanApp from "../../../../../hooks/useTitanApp";

function AutocueSectionSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};
  return (
    <>
      {[...Array(3)].map((_, index) => (
        <div className="autocue_questions_content">
          <Skeleton
            animation="wave"
            variant="rounded"
            // width={24}
            // height={24}
            sx={{ bgcolor: darkMode ? "grey.800" : "grey.300" }}
          />

          <div className="autocue_questions_skeleton">
            {[...Array(3)].map((_, index) => (
              <Skeleton
                key={index}
                sx={{
                  bgcolor: darkMode ? "grey.800" : "",
                  marginBottom: "8px",
                  borderRadius: "16px",
                }}
                height={40}
                animation="wave"
                variant="rounded"
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
}

export default AutocueSectionSkeleton;
